import * as React from 'react'
import { SVGProps } from 'react'
import PropTypes from 'prop-types'
interface SVGRProps {
    title?: string;
    titleId?: string;
}
function SvgMedlemsfordele({
    title,
    titleId,
    ...props
}: SVGProps<SVGSVGElement> & SVGRProps) {
    return (
        <svg
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <g fill="none" fillRule="evenodd">
                <path d="M0 0h24v24H0z" />
                <path
                    d="M4.25 9.541a1 1 0 0 1 .992.872l.008.125v10.965a.998.998 0 0 1-.875.99l-.125.007H1a1 1 0 0 1-.992-.872L0 21.503V10.538c0-.508.381-.928.875-.99L1 9.542h3.25Zm8.414-8.523c.974-.135 2.22.464 2.808 2.557a8.632 8.632 0 0 1-.52 4.393.249.249 0 0 0 .178.32l.059.007H21.5c.663 0 1.299.263 1.768.73a2.488 2.488 0 0 1-.54 3.933 2.237 2.237 0 0 1-.959 3.068 2.24 2.24 0 0 1-1 2.991c.152.309.231.648.231.992 0 .62-.268 1.654-2.014 1.739l-.236.005h-6.5a17.413 17.413 0 0 1-4.108-.47l-.64-.131a39.924 39.924 0 0 0-.347-.068.5.5 0 0 1-.395-.389l-.01-.1V10.511c0-.164.08-.318.216-.41C8.871 8.788 11 5.798 11 3.06a1.995 1.995 0 0 1 1.664-2.043ZM3 19.011a.749.749 0 1 0 .75.748.749.749 0 0 0-.75-.748Z"
                    fill="#297A71"
                    fillRule="nonzero"
                />
            </g>
        </svg>
    )
}
SvgMedlemsfordele.propTypes = {
    title: PropTypes.string,
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    stroke: PropTypes.string,
    color: PropTypes.string,
}
export default SvgMedlemsfordele
